import { render, staticRenderFns } from "./payment-method.vue?vue&type=template&id=4157346e&scoped=true"
import script from "./payment-method.vue?vue&type=script&lang=js"
export * from "./payment-method.vue?vue&type=script&lang=js"
import style0 from "./payment-method.vue?vue&type=style&index=0&id=4157346e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4157346e",
  null
  
)

export default component.exports